import { render, staticRenderFns } from "./MaterialEdit.vue?vue&type=template&id=797d9f26&scoped=true&"
import script from "./MaterialEdit.vue?vue&type=script&lang=ts&"
export * from "./MaterialEdit.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "797d9f26",
  null
  
)

export default component.exports